module.exports = __webpack_public_path__ + "files/900ae85c6f61e8c409cc2ac3d80e076e.png";